import React, { useRef, useState } from "react";
import { BsEnvelopePaper } from "react-icons/bs";
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { IoMapOutline } from "react-icons/io5";
import { RxCountdownTimer } from "react-icons/rx";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const formRef = useRef();
  const [loading, setLoading] = React.useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedRequirements, setSelectedRequirements] = useState([]);
  const [formMessage, setFormMessage] = React.useState({ text: "", type: "" });

  const categories = [
    "Hanging Lights",
    "Acoustic Lights",
    "Indoor Lights",
    "Outdoor Lights",
    "Switches & Sockets",
    "Wires, Cables & Tapes",
    "Sofas, Chairs & Tables",
  ];

  const requirements = [
    { id: "local-domestic", label: "Local / Domestic" },
    { id: "international", label: "International" },
    { id: "retail", label: "Retail" },
    { id: "wholesale", label: "Wholesale" },
  ];

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    setSelectedCategories((prev) =>
      e.target.checked ? [...prev, value] : prev.filter((v) => v !== value)
    );
  };

  const handleRequirementChange = (e) => {
    const value = e.target.value;
    setSelectedRequirements((prev) =>
      e.target.checked ? [...prev, value] : prev.filter((v) => v !== value)
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    formRef.current.querySelector('input[name="categories"]').value =
      selectedCategories.join(", ");
    formRef.current.querySelector('input[name="requirements"]').value =
      selectedRequirements.join(", ");

    emailjs
      .sendForm(
        "service_z77n9i5",
        "template_ytv99ir",
        formRef.current,
        "7v9imcu8QwRtiyHaC"
      )
      .then(
        () => {
          setFormMessage({
            text: "Message sent successfully!",
            type: "success",
          });
          formRef.current.reset();
          setSelectedCategories([]);
          setSelectedRequirements([]);
          setLoading(false);
        },
        (error) => {
          setFormMessage({
            text: "Failed to send message, please try again.",
            type: "error",
          });
          console.error(error.text);
          setLoading(false);
        }
      );
  };

  return (
    <div
      className="container my-5 py-5"
      id="contactpage"
      style={{ fontFamily: "Georgia Pro" }}
    >
      <div className="row g-4 align-items-center justify-content-between">
        {/* Left Side - Contact Info */}
        <div className="col-md-5 rounded helpdiv">
          <h3 className="fw-bold">We're here to help</h3>
          <p>If you have any questions, please feel free to reach us out.</p>

          <div className="d-flex align-items-center py-4">
            <BsEnvelopePaper
              style={{ fontSize: "40px", marginRight: "10px", color: "#333" }}
            />
            <div style={{ fontSize: "18px" }}>
              <p className="mb-2">
                <strong>
                  <a
                    href="mailto:shripal@turbolights.com"
                    className="text-black"
                  >
                    shripal@turbolights.com
                  </a>{" "}
                  <br />
                  <a href="mailto:info@turbolights.com" className="text-black">
                    info@turbolights.com
                  </a>
                </strong>
              </p>
              <p className="mb-0">We reply within 24 hours</p>
            </div>
          </div>

          <div className="d-flex align-items-center py-3">
            <LiaPhoneVolumeSolid
              style={{ fontSize: "40px", marginRight: "10px", color: "#333" }}
            />
            <div style={{ fontSize: "18px" }}>
              <p className="mb-2">
                <strong>Have Any Question?</strong>
              </p>
              <p className="mb-0">
                <a href="tel:+91932298957" className="text-black">
                  +91-932298957
                </a>
                , &nbsp;
                <a href="tel:+919322510122" className="text-black">
                  +91-9322510122
                </a>
              </p>
            </div>
          </div>

          <div className="d-flex align-items-center py-3">
            <IoMapOutline
              style={{ fontSize: "60px", marginRight: "10px", color: "#333" }}
            />
            <div>
              <p className="mb-2">
                <strong>Reach Us At</strong>
              </p>
              <p className="mb-0">
                <a
                  className="text-black"
                  href="https://maps.app.goo.gl/Zigt8N9sqYE1pR967"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shop No, Krishna Niwas, 496, 8, Kalbadevi Rd, Kalbadevi,
                  Mumbai, Maharashtra 400002.
                </a>
              </p>
            </div>
          </div>

          <div className="d-flex align-items-center  py-3">
            <RxCountdownTimer
              style={{ fontSize: "40px", marginRight: "10px", color: "#333" }}
            />
            <div>
              <p className="mb-2">
                <strong>Working Hours</strong>
              </p>
              <p className="mb-0">Mon-Fri, 10:00 AM until 6:00 PM</p>
            </div>
          </div>

          <div className="d-flex align-items-center py-3">
            <LiaPhoneVolumeSolid
              style={{ fontSize: "40px", marginRight: "10px", color: "#333" }}
            />
            <div style={{ fontSize: "18px" }}>
              <p className="mb-2">
                <strong>Need Additional Help?</strong>
              </p>
              <p className="mb-0">
                <a href="tel:+919322510199" className="text-black">
                  +91-9322510199
                </a>
                , &nbsp;
                <a href="tel:+919322293323" className="text-black">
                  +91-9322293323
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="col-md-6">
          <h3 className="fw-bold">Post Your Query</h3>
          <p>
            Your email address will not be published. Required fields are marked
            *
          </p>

          <form id="contactForm" ref={formRef} onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="form-control custom-inputclass"
                name="from_name"
                placeholder="Enter Your Name"
                required
              />
            </div>

            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <input
                  type="email"
                  name="reply_to"
                  className="form-control custom-inputclass"
                  placeholder="Enter Your Email"
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  name="phone"
                  className="form-control custom-inputclass"
                  placeholder="Enter Your Phone Number"
                />
              </div>
            </div>

            <div className="mb-3 pt-2">
              <label className="form-label fw-bold">Category:</label>
              <div className="row">
                {categories.map((item, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="form-check checkdiv p-1">
                      <input
                        className="form-check-input custom-checkbox"
                        type="checkbox"
                        name="categories"
                        value={item}
                        id={`${item
                          .toLowerCase()
                          .replace(/\s+/g, "-")} checkboxid`}
                        onChange={handleCategoryChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={item.toLowerCase().replace(/\s+/g, "-")}
                      >
                        {item}
                      </label>
                    </div>
                  </div>
                ))}
              </div>

              <label className="form-label mt-3">Requirement:</label>
              <div className="row">
                {requirements.map((option) => (
                  <div className="col-md-6" key={option.id}>
                    <div className="form-check checkdiv p-1">
                      <input
                        className="form-check-input custom-checkbox"
                        type="checkbox"
                        name="requirements"
                        value={option.label}
                        id={option.id}
                        onChange={handleRequirementChange}
                      />
                      <label className="form-check-label" htmlFor={option.id}>
                        {option.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-3">
              <textarea
                className="form-control custom-inputclass"
                placeholder="Tell us more about your inquiry.."
                name="message"
                rows="4"
                required
              ></textarea>
            </div>
            <input type="hidden" name="categories" />
            <input type="hidden" name="requirements" />
            <button
              type="submit"
              disabled={loading}
              className="btn bg-black text-white rounded-sm px-4 py-2 shadow-sm"
              style={{ fontFamily: "Now", opacity: loading ? 0.7 : 1 }}
            >
              {loading ? "Sending..." : "Submit"}
            </button>
            {formMessage.text && (
              <div
                className="mt-3"
                style={{
                  backgroundColor:
                    formMessage.type === "success" ? "#d4edda" : "#f8d7da",
                  color: formMessage.type === "success" ? "#155724" : "#721c24",
                  border: `1px solid ${
                    formMessage.type === "success" ? "#c3e6cb" : "#f5c6cb"
                  }`,
                  borderRadius: "5px",
                  padding: "10px 15px",
                  fontSize: "0.95rem",
                  transition: "all 0.3s ease",
                }}
              >
                {formMessage.text}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
